import { Box } from '@twilio-paste/core/box';
import { FormSection, FormSectionHeading } from '@twilio-paste/core/form';

import { AppModel } from '../../../../modules/Apps';

import { CallbackUrl } from './CallbackUrl';

type CallbackUrlsSectionProps = Pick<AppModel, 'twilioSmsInboundStatusCallbackUrl' | 'twilioSmsOutboundStatusCallbackUrl' | 'twilioEventStreamSinkUrl' | 'sendgridEmailWebhookUrl'>

export function CallbackUrlsSection({
  twilioSmsInboundStatusCallbackUrl,
  twilioSmsOutboundStatusCallbackUrl,
  twilioEventStreamSinkUrl,
  sendgridEmailWebhookUrl,
}: CallbackUrlsSectionProps) {

  if (!twilioSmsInboundStatusCallbackUrl && !twilioSmsOutboundStatusCallbackUrl && !twilioEventStreamSinkUrl && !sendgridEmailWebhookUrl) {
    return null;
  }

  return (
    <FormSection>
      <FormSectionHeading>Status Callback Urls</FormSectionHeading>
      <Box marginTop="space40">
        {twilioSmsInboundStatusCallbackUrl && (<CallbackUrl
          label='SMS Inbound Callback URL'
          url={twilioSmsInboundStatusCallbackUrl}
        />)}
        {twilioSmsOutboundStatusCallbackUrl && (<CallbackUrl
          label='SMS Outbound Callback URL'
          url={twilioSmsOutboundStatusCallbackUrl}
        />)}
        {twilioEventStreamSinkUrl && (<CallbackUrl
          label='Voice Callback URL'
          url={twilioEventStreamSinkUrl}
        />)}
        {sendgridEmailWebhookUrl && (<CallbackUrl
          label='Email Callback URL'
          url={sendgridEmailWebhookUrl}
        />)}
      </Box>
    </FormSection>
  );
}
